export default function ($scope, fileImportTypes, uploadImports) {
    $scope.importTypes = [];
    $scope.selectedImportType = null;
    $scope.files = [];

    /* --- */

    $scope.upload = upload;

    /* --- */

    fileImportTypes.then(types => {
        $scope.importTypes = types;
        $scope.selectedImportType = $scope.importTypes[0];
    });

    /* --- */

    function upload() {
        uploadImports($scope.selectedImportType.id, $scope.files);
    }
}



// WEBPACK FOOTER //
// ./Client/app/data-import-export/controllers/upload/uploadCtrl.js